import { useEffect, useMemo, useState } from "react";
import Modal from "../../components/modal/modal.component";
import { UtilsService } from "../../services/utils";
import { RegistersService } from "../../services/operation/registers";

function PaymentsModal({ show, data, setShow }: any) {
  const [pagos, setPagos] = useState([]);

  const totalPaid = useMemo(() => {
    if(!data || !data.customer) return 0;
    const customer = data.customer;

    const paid = customer.pagos.reduce(( a: number, b: any) => a + b.monto, 0);

    return paid;
  }, [data]);

  const isPaid = useMemo(() => {
    if(!data || !data.customer) return 0;
    const customer = data.customer;

    const total = customer.valor_total;

    const paid = customer.pagos.reduce(( a: number, b: any) => a + b.monto, 0);

    return paid >= total 
  }, [data])

  const getReceipt = async(name: string) => {
    const data = await RegistersService.getFileReceipt(name);
    window.open(data.url,  "_blank");
  }

  useEffect(() => {
    if(data && data.customer) {
      setPagos(data.customer.pagos)
    } else {
      setPagos([])
    }
  }, [data])
  
  return (
    <Modal show={show} className="modal-lg">
      <div className="modal-header">
        <h3 className="modal-title">Depósitos</h3>
        <div
          className="btn btn-icon btn-sm btn-active-light-primary ms-2"
          onClick={setShow}
        >
          <i className="ki-duotone ki-cross fs-1">
            <span className="path1" />
            <span className="path2" />
          </i>
        </div>
      </div>
      <div className="modal-body">
        {
          !isPaid && (
            <div className="alert bg-light-warning border border-warning border-dashed d-flex flex-column flex-sm-row w-100 p-5 ">
              <i className="fa-solid fa-circle-exclamation fs-2hx text-warning me-4 mb-5 mb-sm-0"></i>
              <div className="d-flex flex-column">
                <h5 className="mb-1">Atención</h5>
                <span className="mb-3">
                  Aún hay pagos pendientes para {data?.customer?.customer?.name} - {data?.customer?.field?.name} con la siguiente información:
                </span>
                <span className="fw-bold">Valor total: ${UtilsService.numberFormat(data?.customer?.valor_total)}</span>
                <span className="fw-bold">Fruta pagada: ${UtilsService.numberFormat(totalPaid)}</span>
                <span className="fw-bold">Adeudo: ${UtilsService.numberFormat(data?.customer?.valor_total - totalPaid)}</span>
              </div>
            </div>
          )
        }
        

        <div className="table-responsive">
          <table className="table table-rounded border gy-7 gs-7">
            <thead>
              <tr className="fw-semibold fs-6 text-gray-800 border-bottom-2 border-gray-200">
                <th>Fecha</th>
                <th>Monto</th>
                <th>Concepto</th>
                <th className="text-center">Comprobante</th>
              </tr>
            </thead>
            <tbody>
              {
                pagos.map((pago: any, index: number) => (
                  <tr key={index}>
                    <td className="align-middle">{UtilsService.dateFormat(pago.date, 'DD/MM/YYYY')}</td>
                    <td className="align-middle text-nowrap">${UtilsService.numberFormat(pago.monto)}</td>
                    <td className="align-middle text-nowrap">{pago.concepto}</td>
                    <td className="align-middle text-center">
                      <button className="btn btn-light-secondary" onClick={() => getReceipt(pago.comprobante)}>
                        <i className="ki-duotone ki-paper-clip"></i>
                      </button>
                    </td>
                  </tr>
                ))
              }
            </tbody>
          </table>
        </div>
      </div>
      <div className="modal-footer">
        <button className="btn btn-primary" type="button" onClick={setShow}>
          Cerrar
        </button>
      </div>
    </Modal>
  );
}

export default PaymentsModal;
